import BaseApi from "./baseApi";

export default class ReviewApi extends BaseApi {
    async getReviewInsurers(): Promise<Insurer[]> {
        const url = `/api/insurers/Review`;
        return await this.fetchGet(url);
    }
}
